// NHANES
const NHANES_ALC_FREQ = [
  'Never',
  'Daily to 3-4x/Week',
  'Daily to 3-4x/Week',
  'Daily to 3-4x/Week',
  '2x/Week to 2-3x/Month',
  '2x/Week to 2-3x/Month',
  '2x/Week to 2-3x/Month',
  'Monthly to 1-2x/Year',
  'Monthly to 1-2x/Year',
  'Monthly to 1-2x/Year',
  'Monthly to 1-2x/Year',
  'Refused',
  "Don't Know",
];

const NHANES_DIABETES_HT_AGE = [
  '<=12',
  '13-79',
  '>=80',
  'Refused',
  "Don't Know",
];

const NHANES_DIABETES = ['No', 'Borderline', 'Yes', 'Refused', "Don't Know"];

const NHANES_EDUCATION = [
  'Less than 9th grade',
  '9-11th grade/12th no diploma',
  'High school graduate/GED',
  'Some college or AA degree',
  'College graduate or above',
];

const NHANES_INCOMES = [
  '$ 0 to $ 4,999',
  '$ 5,000 to $ 9,999',
  '$10,000 to $14,999',
  '$15,000 to $19,999',
  '$20,000 to $24,999',
  '$25,000 to $34,999',
  '$35,000 to $44,999',
  '$45,000 to $54,999',
  '$55,000 to $64,999',
  '$65,000 to $74,999',
  '$75,000 to $99,999',
  '$100,000 and Over',
  'Refused',
  "Don't know",
  'Under $20,000',
  '$20,000 and Over',
];

const NHANES_RACE_RIDRETH3 = [
  'Mexican American',
  'Other Hispanic',
  'Non-Hispanic White',
  'Non-Hispanic Black',
  'Non-Hispanic Asian',
  'Other Race - Including Multi-Racial',
  'Unknown',
];

// UMD PD HOME
const UMD_PD_HY_CLASS = ['early', 'middle', 'advanced'];
const UMD_PD_HY_STAGE = [
  '0.0',
  '1.0',
  '1.5',
  '2.0',
  '2.5',
  '3.0',
  '4.0',
  '5.0',
];
const UMD_PD_EDU = [
  'Elem school',
  'High school',
  'Trade school',
  'College',
  'Adv degree',
  'Unavailable',
];
const UMD_PD_INCOME = [
  '< $50K',
  '$50K - $100K',
  '$100K - $150K',
  '> $150K',
  'Unavailable',
];
const UMD_PD_MARITAL_STATUS = [
  'Married',
  'Widowed',
  'Separated',
  'Divorced',
  'Single',
  'Unavailable',
];

// Other
const ABX_DURATION = [
  '0 days',
  '1-2 days',
  '3-7 days',
  '>1-4 weeks',
  '>4 weeks',
];

// variables indexed by name
const VAR_CATEGORIES = {
  // NHANES
  'Alcohol Frequency in Past Year': NHANES_ALC_FREQ,
  'Age told had diabetes': NHANES_DIABETES_HT_AGE,
  'Age told had hypertension': NHANES_DIABETES_HT_AGE,
  'Annual family income|INDFMIN2': NHANES_INCOMES,
  'Annual household income|INDHHIN2': NHANES_INCOMES,
  Diabetes: NHANES_DIABETES,
  'Education level|DMDEDUC2': NHANES_EDUCATION,
  'Marital Status|DMDMARTZ': [
    'Married/Living with Partner',
    'Widowed/Divorced/Separated',
    'Never married',
    'Refused',
  ],
  'Pregnancy status|RIDEXPRG': [
    'Pregnant',
    'Not pregnant',
    'Cannot ascertain',
    'Missing',
  ],
  'Race|RIDRETH3': NHANES_RACE_RIDRETH3,
  // UMD PD HOME
  'Hoehn and Yahr Class': UMD_PD_HY_CLASS,
  'Hoehn and Yahr Stage': UMD_PD_HY_STAGE,
  Education: UMD_PD_EDU,
  Income: UMD_PD_INCOME,
  'Marital Status': UMD_PD_MARITAL_STATUS,
  // Other
  abx_duration: ABX_DURATION,
};

// Hard-coded sort order for all known categorical and ordinal variables
//
// v - variable
// arr - array/list of items to sort
// accessorFn - function that produces category when applied to list element
//
export function sortByCategory(v, arr, accessorFn) {
  let vname = 'label' in v ? v.label : v.scale;
  let v_cats = null;
  if (vname in VAR_CATEGORIES) {
    v_cats = VAR_CATEGORIES[vname];
  } else if ('abbreviation' in v) {
    v_cats = VAR_CATEGORIES[v.abbreviation];
  }

  // variable with hard-coded order defined in VAR_CATEGORIES
  if (v_cats != null) {
    let cat_index = {};
    var ind = 1;
    v_cats.forEach(vc => {
      cat_index[vc] = ind++;
    });

    let getIndex = function(c) {
      return c in cat_index ? cat_index[c] : ind + 1;
    };

    let sortFn = function(a, b) {
      const av = accessorFn(a);
      const bv = accessorFn(b);
      var a_i = getIndex(av);
      var b_i = getIndex(bv);
      if (a_i < b_i) return -1;
      if (b_i < a_i) return 1;
      return av.localeCompare(bv);
    };

    return arr.sort(sortFn);
  }
  // all others
  else {
    // check whether categories can be treated as integers/floats
    let allNumeric = true;
    arr.forEach(e => {
      let ev = accessorFn(e);
      if (!String(ev).match(/^[\d]+(\.\d+)?$/)) allNumeric = false;
    });

    if (allNumeric) {
      return arr.sort((x, y) => x - y);
    } else {
      return arr.sort((x, y) => accessorFn(x).localeCompare(accessorFn(y)));
    }
  }
}

export default sortByCategory;
